<script setup lang="ts">
    defineProps<{
        value: number | null;
    }>();
</script>

<template>
    <span class="tag display-sequence-tag">
        {{ value ?? '' }}
    </span>
</template>

<style scoped>
.display-sequence-tag {
    min-width: 2.5rem;
    font-variant-numeric: tabular-nums;
}
</style>
